import { render, staticRenderFns } from "./AdminEventCover.vue?vue&type=template&id=d51302c2&"
import script from "./AdminEventCover.vue?vue&type=script&lang=js&"
export * from "./AdminEventCover.vue?vue&type=script&lang=js&"
import style0 from "./AdminEventCover.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports